import { render, staticRenderFns } from "./Page019.vue?vue&type=template&id=b6f252f6&scoped=true&"
import script from "./Page019.vue?vue&type=script&lang=js&"
export * from "./Page019.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f252f6",
  null
  
)

export default component.exports